// SIGNALR
export const ON_IMPORTACAO_STATE = "ON_IMPORTACAO_STATE";
export const CLEAN_IMPORTACAO_STATE = "CLEAN_IMPORTACAO_STATE";
export const ON_DOWNLOAD_COMPETENCIA_STATE = "ON_DOWNLOAD_COMPETENCIA_STATE";
export const CLEAN_DOWNLOAD_COMPETENCIA_STATE = "CLEAN_DOWNLOAD_COMPETENCIA_STATE";

// MENU
export const SET_OPEN_MENU = "SET_OPEN_MENU";
export const SET_OPEN_SEGURADO_FORM = "SET_OPEN_SEGURADO_FORM";
export const SET_ULTIMO_UPDATE_LISTA_SEGURADOS = "SET_ULTIMO_UPDATE_LISTA_SEGURADOS";
export const SET_ULTIMO_UPDATE_NIT = "SET_ULTIMO_UPDATE_NIT";

// MAIN
export const SET_LOADING = "SET_LOADING";

// SEGURADO
export const LIMPA_DEFINICOES_SEGURADO = "LIMPA_DEFINICOES_SEGURADO";
export const SET_TAB_INDEX = "SET_TAB_INDEX";
export const SET_PARAMS_FILTER_IMPORTACAO = "SET_PARAMS_FILTER_IMPORTACAO";
export const SET_OPEN_BUSCA_AVANCADA = "SET_OPEN_BUSCA_AVANCADA";
export const SET_PARAMS_FILTER_RELACOES_PREVIDENCIARIAS = "SET_PARAMS_FILTER_RELACOES_PREVIDENCIARIAS";
export const SET_PARAMS_FILTER_RESULTADOS = "SET_PARAMS_FILTER_RESULTADOS";
export const SET_PARAMS_FILTER_RESTITUICAO = "SET_PARAMS_FILTER_RESTITUICAO";


